import React, { memo, useCallback, useState } from 'react';

import cn from 'classnames';
import Image from 'next/legacy/image'

import { Button, Popover } from '@element/index'
import { useIsomorphicLayoutEffect } from '@lib/hooks'
import I18n from '@utils/i18n'
import p from '@utils/Transfrom';

import { KlineMap, MainIndicators, MainTimeType, MoreTimeType, SecondIndicators } from './constant'
import { getIframeHtml, getKLineValue, saveKLineValue } from './utils'

import styles from './index.module.css'

function sendMessageToIframe (msg) {
  // 获取iframe元素
  const iFrame = document.getElementById('tradingViewIframe')
  iFrame.contentWindow.postMessage(msg, '*');
}

const KLine = (props) => {
  const [visibleTimeTypePopover, setVisibleTimeTypePopover] = useState(false)
  const [visibleIndicatorPopover, setVisibleIndicatorPopover] = useState(false)
  const [showMainIndicator, setShowMainIndicator] = useState(true)
  const [showSecondIndicator, setShowSecondIndicator] = useState(true)
  const [activeMainIndicator, setActiveMainIndicator] = useState([])
  const [activeSecondIndicator, setActiveSecondIndicator] = useState([])
  const [activeTimeType, setActiveTimeType] = useState('15') // 时间间隔
  const [iframe, setIframe] = useState('')

  useIsomorphicLayoutEffect(() => {
    if (props.coinCode && typeof props.precision !== 'undefined') {
      const klineValue = getKLineValue();
      const currActiveTimeType = klineValue.activeTimeType ?? activeTimeType;
      const currActiveMainIndicator = klineValue.activeMainIndicator ?? activeMainIndicator;
      const currActiveSecondIndicator = klineValue.activeSecondIndicator ?? activeSecondIndicator;
      setActiveTimeType(currActiveTimeType);
      setActiveMainIndicator(currActiveMainIndicator);
      setActiveSecondIndicator(currActiveSecondIndicator);
      setIframe(getIframeHtml(currActiveTimeType, props.coinCode, props.precision, currActiveMainIndicator, currActiveSecondIndicator))
    }
  }, [props.coinCode, props.precision])
  const onClickTimeFrame = useCallback((timeType) => {
    setActiveTimeType(timeType)
    saveKLineValue({ activeTimeType: timeType });
    setIframe(getIframeHtml(timeType, props.coinCode, props.precision, activeMainIndicator.join(','), activeSecondIndicator.join(',')))
  }, [props.coinCode, props.precision, activeMainIndicator, activeSecondIndicator])

  const onClickMainSwitch = useCallback(() => {
    if (showMainIndicator) {
      setActiveMainIndicator([])
      saveKLineValue({ activeMainIndicator: [] });
      sendMessageToIframe({ newMainStudy: [] })
      setShowMainIndicator(false)
      setVisibleTimeTypePopover(false)
    }
  }, [showMainIndicator])
  const onClickSecondSwitch = useCallback(() => {
    if (showSecondIndicator) {
      setActiveSecondIndicator([])
      saveKLineValue({ activeSecondIndicator: [] });
      sendMessageToIframe({ newSecondStudy: [] })
      setShowSecondIndicator(false)
      setVisibleTimeTypePopover(false)
    }
  }, [showSecondIndicator])
  const onClickMainIndicator = useCallback((mainIndicator) => {
    const index = activeMainIndicator.indexOf(mainIndicator)
    let newArr = []
    if (index === -1) {
      newArr = [...activeMainIndicator, ...[mainIndicator]]
    } else {
      activeMainIndicator.splice(index, 1)
      newArr = [...activeMainIndicator]
    }
    setActiveMainIndicator(newArr)
    saveKLineValue({ activeMainIndicator: newArr });
    if (newArr.length) {
      setShowMainIndicator(true)
    }

    sendMessageToIframe({ newMainStudy: newArr })
  }, [activeMainIndicator])

  const onClickSecondIndicator = useCallback((mainIndicator) => {
    const index = activeSecondIndicator.indexOf(mainIndicator)
    let newArr = []
    if (index === -1) {
      newArr = [...activeSecondIndicator, ...[mainIndicator]];
    } else {
      activeSecondIndicator.splice(index, 1)
      newArr = [...activeSecondIndicator]
    }
    setActiveSecondIndicator(newArr)
    saveKLineValue({ activeSecondIndicator: newArr });
    if (newArr.length) {
      setShowSecondIndicator(true)
    }

    sendMessageToIframe({ newSecondStudy: newArr })
  }, [activeSecondIndicator]);
  return (
    <div className={styles.main}>
      {
        MainTimeType.map((timeType) => {
          return (
            <Button
              key={timeType}
              type="text"
              onClick={() => {
                onClickTimeFrame(timeType)
              }}
              className={cn(styles.btn, { [styles.activeBtn]: activeTimeType === timeType })}
            >
              <span className='DINPro'>{I18n.t(KlineMap[timeType])}</span>
            </Button>
          )
        })
      }

      <Popover
        placement={'bottom'}
        trigger="click"
        hasArrow
        visible={visibleTimeTypePopover}
        onVisibleChange={visible => setVisibleTimeTypePopover(visible)}
        content={(
          <div className={styles.timeTypePopover}>
            {
              MoreTimeType.map((timeType) => {
                return (
                  <Button
                    key={timeType}
                    type="text"
                    onClick={() => {
                      onClickTimeFrame(timeType)
                      setVisibleTimeTypePopover(false)
                    }}
                    className={cn(styles.timeBtn, { [styles.activeMoreBtn]: activeTimeType === timeType })}
                  >
                    <span>{I18n.t(KlineMap[timeType])}</span>
                    <Image
                      alt='kikitrade'
                      src={require(activeTimeType === timeType ? '@images/icon/fav.webp' : '@images/icon/unfav.webp')}
                      width={p(28)}
                      height={p(28)}
                    />
                  </Button>
                )
              })
              }
          </div>
        )}
      >
        <Button
          type="text"
          onClick={() => setVisibleTimeTypePopover(true)}
          className={cn(styles.btn, { [styles.activeBtn]: MoreTimeType.indexOf(activeTimeType) !== -1 })}
        >
          {MoreTimeType.indexOf(activeTimeType) !== -1 ? I18n.t(KlineMap[activeTimeType]) : I18n.t('more')}
          <span
            onClick={onClickMainSwitch}
            className={cn('icon', styles.upDownIcon, {
              'icon-up': visibleTimeTypePopover && MoreTimeType.indexOf(activeTimeType) === -1,
              'icon-down': !visibleTimeTypePopover && MoreTimeType.indexOf(activeTimeType) === -1,
              'icon-up-active': visibleTimeTypePopover && MoreTimeType.indexOf(activeTimeType) !== -1,
              'icon-down-active': !visibleTimeTypePopover && MoreTimeType.indexOf(activeTimeType) !== -1
            })}
          />
        </Button>
      </Popover>
      <Popover
        placement={'bottomRight'}
        trigger="click"
        hasArrow
        visible={visibleIndicatorPopover}
        onVisibleChange={visible => setVisibleIndicatorPopover(visible)}
        content={(
          <div className={styles.indicatorPopover}>
            <div className={styles.titleView}>
              <span className={cn('Medium', styles.titleLabel)}>{I18n.t('mainStudy')}</span>
              <span
                onClick={onClickMainSwitch}
                className={cn('icon', styles.eyeIcon, {
                  'icon-eyeOutlined': showMainIndicator,
                  'icon-eyeInvisibleOutlined': !showMainIndicator
                })}
              />
            </div>
            {
              MainIndicators.map((indicatorType) => {
                return (
                  <Button
                    key={indicatorType}
                    type="text"
                    onClick={() => {
                      onClickMainIndicator(indicatorType)
                      setVisibleIndicatorPopover(false)
                    }}
                    className={[styles.indicatorBtn, activeMainIndicator.indexOf(indicatorType) !== -1 ? styles.activeIndicatorBtn : null]}
                  >
                    <span>{indicatorType}</span>
                  </Button>
                )
              })
            }
            <div className={cn(styles.titleView, styles.secondIndicatorsView)}>
              <span className={cn('Medium', styles.titleLabel)}>{I18n.t('secondStudy')}</span>
              <span
                onClick={onClickSecondSwitch}
                className={cn('icon', styles.eyeIcon, {
                  'icon-eyeOutlined': showSecondIndicator,
                  'icon-eyeInvisibleOutlined': !showSecondIndicator
                })}
              />
            </div>
            {
              SecondIndicators.map((indicatorType) => {
                return (
                  <Button
                    key={indicatorType}
                    type="text"
                    onClick={() => {
                      onClickSecondIndicator(indicatorType)
                      setVisibleIndicatorPopover(false)
                    }}
                    className={[styles.indicatorBtn, activeSecondIndicator.indexOf(indicatorType) !== -1 ? styles.activeIndicatorBtn : null]}>
                    <span>{indicatorType}</span>
                  </Button>
                )
              })
            }
          </div>
        )}
      >
        <Button
          type="text"
          onClick={() => setVisibleIndicatorPopover(true)} className={[styles.btn]}
        >
          {I18n.t('indicator')}
        </Button>
      </Popover>
      <div dangerouslySetInnerHTML={ { __html: iframe }} />
    </div>
  )
}

const Memo = memo(KLine);
export default Memo;
